import { render } from "./DepartmentSelect.vue?vue&type=template&id=44890929&ts=true"
import script from "./DepartmentSelect.vue?vue&type=script&lang=ts"
export * from "./DepartmentSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__